import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const ResetPasswordFormValidationSchema = yup.object({
    newPassword: RHFUserValidationRules.password,
    newPasswordRepeat: RHFUserValidationRules.passwordRepeat
});

export type ResetPasswordFormValues = yup.InferType<
    typeof ResetPasswordFormValidationSchema
>;
